import { formatAsCurrency } from '../utils.js';

class TiersView {
  constructor() {
    this._parentEl = document.querySelector('#tiers');
  }

  render(data) {
    // 1) Clear parent container
    this._parentEl.innerHTML = '';

    // 2) Generate markup
    const markup = data.map(this._generateTierMarkup).join('');

    // 3) Add elements to the DOM
    this._parentEl.insertAdjacentHTML('afterbegin', markup);
  }

  _generateTierMarkup(tier) {
    const { title, text, minPledge, stock } = tier;

    return `
      <div class="tier ${stock < 1 ? 'tier--disabled' : ''}">
        <header class="tier__header">
          <h3 class="heading heading--tertiary">${title}</h3>
          <span class="label-minimum">
            Pledge ${formatAsCurrency(minPledge)} or more
          </span>
        </header>

        <p class="paragraph tier__body">
          ${text}
        </p>

        <div class="stock">
          <span class="stock__number">${stock}</span>
          <span class="stock__label">left</span>
        </div>

        <button class="btn btn-primary open-modal" ${
          stock < 1 ? 'disabled' : ''
        }>Select Reward</button>
      </div>
    `;
  }
}

export default new TiersView();
